"use client";

import React from "react";
import Image from "next/image";
import { cn } from "@/utils/cn";

interface StartJourneyButtonProps {
  label?: string;
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  className?: string;
}

export default function StartJourneyButton({
  label = "BẮT ĐẦU HÀNH TRÌNH",
  onClick,
  className,
}: StartJourneyButtonProps) {
  return (
    <button
      onClick={onClick}
      className={cn(
        "group relative inline-flex items-center gap-2.5 px-4 py-1.5 md:px-5 md:py-2 rounded-full border border-white/25 hover:border-white/60 bg-black/25 hover:bg-white/10 backdrop-blur-sm transition-all duration-300 cursor-pointer focus:outline-none",
        className,
      )}
    >
      <span className="text-[10px] md:text-[11px] font-medium uppercase tracking-[0.14em] text-white transition-colors whitespace-nowrap">
        {label}
      </span>
      <Image
        src="/icons/arrow_outward.svg"
        alt="arrow"
        width={14}
        height={14}
        className="w-3 h-3 md:w-3.5 md:h-3.5 invert brightness-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform duration-300 object-contain"
      />
    </button>
  );
}
